import { Button, Card, Form, InputNumber, Radio, Space } from 'antd';
import React, { useState } from 'react';

import { checkErrorIfMemberLevelEnabled } from './helpers';
import styles from './index.module.scss';
import type { PointParamsSettingFormValues } from './types';

const { Item, useForm, useWatch } = Form;

export const PointParamsSetting = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [form] = useForm<PointParamsSettingFormValues>();

  const publishAnnouncement = () => {
    // TODO: 邏輯待寫
    console.log('Published an announcement');
  };

  const onFormFinish = (formValues: PointParamsSettingFormValues) => {
    setIsSubmitting(true);
    console.log(formValues);

    // TODO: 需要處理如果選擇了開放會員儲值等級功能，就必須去驗證會員等級的三個欄位，至少填其一（或是即使開放了也可以全空？需要跟後端討論）

    setTimeout(() => {
      setIsEditing(false);
      setIsSubmitting(false);
    }, 1500);
  };

  const isMemberLevelEnabled = useWatch('isMemberLevelEnabled', form);
  const silverLevel = useWatch(['memberLevelThresholds', 'silver'], form);
  const goldLevel = useWatch(['memberLevelThresholds', 'gold'], form);
  const diamondLevel = useWatch(['memberLevelThresholds', 'diamond'], form);

  const isAllLevelFieldsEmpty = checkErrorIfMemberLevelEnabled({
    silverLevel,
    goldLevel,
    diamondLevel,
  });

  const shouldMemberLevelFieldsShowError =
    isMemberLevelEnabled && isAllLevelFieldsEmpty;

  return (
    <Card>
      <Space
        direction="vertical"
        size="large"
        className={styles.cardContentContainer}
      >
        <Form form={form} onFinish={onFormFinish} className={styles.form}>
          <Space direction="vertical">
            <h4>點數參數設定</h4>
            <Space align="baseline">
              <p className={styles.requiredMark}>
                1.點數提供現金儲值方式（1點＝
              </p>
              <Item
                name="cashConversionRate"
                className={styles.fieldItem}
                rules={[{ required: true, message: '必填欄位' }]}
              >
                <InputNumber
                  min={1}
                  step={1}
                  placeholder="60"
                  disabled={!isEditing || isSubmitting}
                />
              </Item>
              <p>元）</p>
            </Space>
            <Space align="baseline" size="middle">
              <p className={styles.requiredMark}>2.是否開放會員儲值等級功能</p>
              <Item
                name="isMemberLevelEnabled"
                className={styles.fieldItem}
                rules={[{ required: true, message: '請選擇任一個' }]}
              >
                <Radio.Group disabled={!isEditing || isSubmitting}>
                  <Radio value={true}>是</Radio>
                  <Radio value={false}>否</Radio>
                </Radio.Group>
              </Item>
            </Space>
            <Space align="baseline">
              <p className={styles['ml-placeholder']}>
                3.銀牌會員等級需擁有點數
              </p>
              <Item
                name={['memberLevelThresholds', 'silver']}
                initialValue={null}
                rules={[
                  {
                    required: shouldMemberLevelFieldsShowError,
                    message: '至少填寫一種',
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  step={1}
                  placeholder="10000"
                  disabled={!isEditing || isSubmitting}
                />
              </Item>
              <p>點、黃金會員等級需擁有點數</p>
              <Item
                name={['memberLevelThresholds', 'gold']}
                initialValue={null}
                rules={[
                  {
                    required: shouldMemberLevelFieldsShowError,
                    message: '至少填寫一種',
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  step={1}
                  placeholder="30000"
                  disabled={!isEditing || isSubmitting}
                />
              </Item>
              <p>點、鑽石會員等級需擁有點數</p>
              <Item
                name={['memberLevelThresholds', 'diamond']}
                initialValue={null}
                rules={[
                  {
                    required: shouldMemberLevelFieldsShowError,
                    message: '至少填寫一種',
                  },
                ]}
              >
                <InputNumber
                  min={0}
                  step={1}
                  placeholder="50000"
                  disabled={!isEditing || isSubmitting}
                />
              </Item>
              <p>點。</p>
            </Space>
          </Space>
        </Form>
        <Space align="center" size="middle" className={styles.actionButtons}>
          <Button
            type="primary"
            disabled={isEditing || isSubmitting}
            onClick={publishAnnouncement}
          >
            發佈公告
          </Button>
          {isEditing && !isSubmitting && (
            <Button
              disabled={isSubmitting}
              onClick={() => {
                form.resetFields();
                setIsEditing(false);
              }}
            >
              取消
            </Button>
          )}
          <Button
            type={isEditing ? 'primary' : 'default'}
            disabled={isSubmitting}
            onClick={isEditing ? form.submit : () => setIsEditing(true)}
          >
            {isEditing ? '更新' : '編輯'}
          </Button>
        </Space>
      </Space>
    </Card>
  );
};
